<template>
	<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<g filter="url(#filter0_i)">
			<path d="M11.3342 6C11.3342 8.93025 9.06681 11.25 6.33703 11.25C3.60726 11.25 1.33984 8.93025 1.33984 6C1.33984 3.06975 3.60726 0.75 6.33703 0.75C9.06681 0.75 11.3342 3.06975 11.3342 6Z" :stroke="fill_color" stroke-width="1.5"/>
			<path d="M3.224 10.25L9.68959 2" :stroke="fill_color" stroke-width="1.5"/>
		</g>
		<defs>
			<filter id="filter0_i" x="0.589844" y="0" width="11.4944" height="16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix"/>
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
				<feOffset dy="4"/>
				<feGaussianBlur stdDeviation="2"/>
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
			</filter>
		</defs>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>